<template>
  <div class="card h-100">
    <div
      style="background: #dee2e6; height: 8.5rem"
      class="d-flex justify-content-center align-items-center card-img-top overflow-hidden"
      :class="(customheight || customwidth) && 'p-1'"
    >
      <div
        :style="{
          background:
            'url(' +
            image +
            ') center / ' +
            (customheight || customwidth ? 'auto 8rem' : contain ? 'contain' : 'cover') +
            ' no-repeat',
          height: customheight ? customheight : '100%',
          width: customwidth ? customwidth : '100%',
        }"
      ></div>
    </div>
    <div class="card-body">
      <h6 class="card-title text-secondary fw-bold mb-0" style="word-wrap: anywhere">
        {{ title }}
      </h6>
      <div v-if="subtitle" class="small text-muted">{{ subtitle }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    image: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    customheight: {
      type: String,
      default: '',
    },
    customwidth: {
      type: String,
      default: '',
    },
    contain: {
      type: Boolean,
      default: false,
    }
  },
  setup() {
    return {};
  },
};
</script>

<style lang="scss" scoped></style>
